import styled from 'styled-components/macro';

const BodyContainer = styled.div<{ tableWidth?: number | undefined }>`
  position: relative;
  z-index: ${({ theme }) => theme.zIndexPalette.high};
  border: 1px solid ${({ theme }) => theme.colorPalette.grey.grey5};
  border-radius: 5px;
  padding: 10px;
  margin-bottom: 10px;
  width: 100%;
  .SpreadsheetGridContainer {
    display: inline-block;
  }
`;

export { BodyContainer };
